import {
  type GraphView,
  type GraphViewPreviewable,
  graphOverlayToRequest,
} from '@ipfabric/utils';
import { ___, partialApply } from '@ipfabric/utils/fp/partialApply';
import { getPresetDraftFunctionByMode } from 'components/Graph/commands/helpers/getPresetFunctionByMode';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import { exitTopologyPresetEditMode } from 'components/Graph/commands/settings/exitTopologyPresetEditMode';
import { setAppliedPreset } from 'components/Graph/commands/settings/setAppliedPreset';
import { mergeSettingsToPreset } from 'components/Graph/helpers/mergeSettingsToPreset';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { pipe } from 'fp-ts/lib/function';

export interface LoadViewCommand {
  view: GraphView | GraphViewPreviewable;
  viewUrlId?: string;
}

export const loadView: GraphCommandFactory<LoadViewCommand> = (
  cmdContext,
  dispatch,
) => {
  const setAppliedPresetFromView = (view: GraphView | GraphViewPreviewable) => {
    pipe(
      cmdContext.getState(),
      getPresetDraftFunctionByMode[view.parameters.type],
      partialApply(mergeSettingsToPreset, view.settings, ___),
      (preset) => dispatch(setAppliedPreset, { preset }),
    );
  };

  return async (command: LoadViewCommand) => {
    cmdContext.updateState((draft) => {
      draft.loadViewDialog.loadedView = command.view;
    });

    dispatch(exitTopologyPresetEditMode);

    setAppliedPresetFromView(command.view);

    await dispatch(loadGraph, {
      collapsedNodeGroups: command.view.collapsedNodeGroups,
      hiddenNodeSns: command.view.hiddenNodes,
      nodePositions: command.view.positions,
      overlay: graphOverlayToRequest(command.view.overlay ?? null) ?? 'none',
      parameters: command.view.parameters,
      transferPreviousState: false,
    });

    cmdContext.updateState((draft) => {
      draft.sharedViewId = command.viewUrlId ?? null;
    });
  };
};
